var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.TOURNAMENT.attributes.playoff_type === 'single_elimination')?_c('single-elimination'):_c('double-elimination')}
var staticRenderFns = []

export { render, staticRenderFns }